/**!
 * Created by Leonardo Cheslacki on 15/03/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import HelpersController from './HelpersController';

import WithType from './WithType';

let _this = {};

/**
 *
 */
class HelpersResize extends HelpersController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            errors: null
        };

        _this = this;
    };

    makeResponsive = () => {
        const {
            width,
            height,
            responsive_active,
            responsive_replies,
            scale_active,
            scale_type,
            dom_containers,
            dom_scales
        } = this.props;

        let
            last_inner_width,
            last_inner_height,
            lastS = 1;

        const resizeCanvas = () => {
            let
                dom_container = this.firstArray(dom_containers),
                inner_width = window.innerWidth,
                inner_height = window.innerHeight,
                pRatio = (window.devicePixelRatio || 1),
                xRatio = (inner_width / width),
                yRatio = (inner_height / height),
                sRatio = 1;

            if (responsive_active) {
                if ((responsive_replies === 'width' && last_inner_width === inner_width) || (responsive_replies === 'height' && last_inner_height === inner_height)) {
                    sRatio = lastS;
                } else if (!scale_active) {
                    (inner_width < width || inner_height < height) && (sRatio = Math.min(xRatio, yRatio));
                } else if (scale_type === 'center') {
                    sRatio = Math.min(xRatio, yRatio);
                } else if (scale_type === 'stretch') {
                    sRatio = Math.max(xRatio, yRatio);
                }
            }

            if (this.isArrayIf(dom_containers)) {
                dom_container.width = ((width * pRatio) * sRatio);
                dom_container.height = ((height * pRatio) * sRatio);

                for (let property of dom_containers) {
                    property.style.width = `${(width * sRatio)}px`;
                    property.style.height = `${(height * sRatio)}px`;
                }
            }

            if (this.isArrayIf(dom_scales)) {
                for (let property of dom_scales) {
                    property.style.scale = (pRatio * sRatio);
                }
            }

            last_inner_width = inner_width;
            last_inner_height = inner_height;
            lastS = sRatio;
        }

        /**
         *
         *  Add event resize.
         */
        this.removeListener('resize', 'helpers-resize', resizeCanvas, () => {
            this.addListener(window, 'resize', 'helpers-resize', resizeCanvas);
        });

        resizeCanvas();
    };
}

/**
 *
 * @type {{}}
 */
HelpersResize.propTypes = {
    document: PropTypes.object,
    width: PropTypes.number,
    height: PropTypes.number,
    responsive_active: PropTypes.bool,
    responsive_replies: PropTypes.oneOf(['width', 'height', 'both']),
    scale_active: PropTypes.bool,
    scale_type: PropTypes.oneOf(['center', 'stretch']),
    dom_containers: PropTypes.array,
    dom_scales: PropTypes.array
};

/**
 *
 * @param responsive_active Allow replies, 'true' or 'false'.
 * @param responsive_replies Replies by, 'width', 'height' or 'both'.
 * @param scale_active Scale to fill visible area, 'true' or 'false'.
 * @param scale_type Adjust in display 'center' or stretch to fit 'stretch'
 * @param dom_containers Array containers resize, 'elements'.
 * @param dom_scales Array element scalable, 'elements'.
 */
HelpersResize.defaultProps = {

    document: {},
    width: 1920,
    height: 1080,
    responsive_active: true,
    responsive_replies: 'both',
    scale_active: true,
    scale_type: 'center',
    dom_containers: [],
    dom_scales: []
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(HelpersResize, {className: 'HelpersResize'});
